'use client';
import { useTranslations } from 'next-intl';

export default function NewsHero() {
    const t = useTranslations('News')

    return (
        <div className='mt-6 md:mt-20 px-4 md:px-20 text-start'>
            <div className='flex flex-col md:flex-row justify-start pb-4'>
                <div className='flex-2'>
                        <h1 className='text-3xl md:text-[77px] leading-none text-start font-regular uppercase'>
                            {t('title')}
                        </h1>
                </div>
            </div>
        </div>
    );
}
